// TODO: Use this component for SideDrawer also
import React, { useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { getContext, isAnimationDisabled } from 'common';

import {
  getEasing,
  getDuration
} from 'common/parse-tokens';


const UNMOUNTED_TRANSLATE_RTL = 'translateX(-90000%)';
const UNMOUNTED_TRANSLATE = 'translateX(90000%)';

const HIDDEN_TRANSLATE_LTR = 'translateX(100%)';
const HIDDEN_TRANSLATE_RTL = 'translateX(-100%)';

const VISIBLE_TRANSLATE = 'translateX(0%)';

interface AnimatedOverlayPanelContainerProps {
  children: React.ReactNode;
  visible?: boolean;
  animationProps?: any;
  disableAnimation?: boolean;
  style?: any;
}

const AnimatedOverlayPanelContainer = React.forwardRef<HTMLDivElement, AnimatedOverlayPanelContainerProps>((props: AnimatedOverlayPanelContainerProps, ref) => getContext(({ RTL, disableAnimation }) => {
  const {
    children,
    visible,
    style,
    animationProps,
    disableAnimation: propsdisableAnimation,
    ...otherProps
  } = props;
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);

  const getMargin = () => RTL ? {
    transform: visible
      ? VISIBLE_TRANSLATE
      : isMounted ? HIDDEN_TRANSLATE_RTL : UNMOUNTED_TRANSLATE_RTL,
  } : {
    transform: visible
      ? VISIBLE_TRANSLATE
      : isMounted ? HIDDEN_TRANSLATE_LTR : UNMOUNTED_TRANSLATE,
  };
  const animatedStyle = useSpring({
    config: {
      duration: getDuration(Tokens.SPEED.SPEED_NORMAL),
      ease: visible
        ? getEasing(Tokens.TRANSITION.TRANSITION_DECELERATE)
        : getEasing(Tokens.TRANSITION.TRANSITION_ACCELERATE)
    },
    ...getMargin(),
    ...animationProps,
    immediate: isAnimationDisabled(propsdisableAnimation, disableAnimation),
  });

  return (
    <animated.div
      ref={ref}
      style={{ ...animatedStyle, ...style }}
      {...otherProps}
    >
      {children}
    </animated.div>
  );
}));

AnimatedOverlayPanelContainer.displayName = 'AnimatedOverlayPanelContainer';
AnimatedOverlayPanelContainer.defaultProps = {
  visible: undefined,
  animationProps: undefined,
  style: undefined,
  disableAnimation: undefined,
};

export default AnimatedOverlayPanelContainer;